// extracted by mini-css-extract-plugin
module.exports = {"mb20":"monitor_mb20_1mk84"};